import React, {memo} from 'react';
import About from './Components/About';
import Header from './Components/Header';
import Navbar from './Components/Navbar';
import './Sass/App.scss'
import Skills from "./Components/Skills";
import { Skills as SkillsData } from "./Components/Skills.data"
import PreviousWorks from "./Components/PreviousWorks";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";



function App() {
    return (
        <>
            <Navbar />
            <Header />
            <About />
            <Skills skills={SkillsData} />
            <PreviousWorks />
            <Contact />
            <Footer />
        </>
    );
}

export default memo(App);
